/* eslint-disable no-fallthrough */
import { AbilityBuilder, Ability } from '@casl/ability';

export default function defineAbilityFor(user) {
  const { can, cannot, build } = new AbilityBuilder(Ability);

  if (user.roles.includes('Super Admin')) {
    can('manage', 'all');
  } else {
    let matched = false;

    for (let i = 0; i < user.roles.length; i += 1) {
      switch (user.roles[i]) {
        case 'Admin':
          can('manage', 'all');
          i = user.roles.length; // exit the rest
          matched = true;
        case 'Utilities':
          can('see', 'Utilities');
          matched = true;
          break;
        case 'Customer Service':
          can('manage', 'orders');
          can('manage', 'inventory');

          matched = true;
        case 'Shipping':
          can('manage', 'orders');
          can('manage', 'pick');
          can('manage', 'pack');
          can('manage', 'ship');
          can('manage', 'inventory');
          can('manage', 'warehouse');
          can('manage', 'putaway');

          matched = true;
        case 'Part Entry':
          can('manage', 'inventory');
          can('manage', 'putaway');
          matched = true;
        case 'Returns':
          can('manage', 'orders');
          matched = true;
        case 'Techs':
          can('manage', 'orders');
          can('manage', 'inventory');
          matched = true;
        case 'Receiving':
          can('manage', 'warehouse');
          can('manage', 'putaway');
          matched = true;
        case 'guest':
        default:
          break;
      }

      if (!matched) {
        cannot('manage', 'all');
      }
    }
  }

  return build();
}
